import { sharedColors, sharedFonts } from '../../assets/shared.styles';

export const styles = {
  mainBox: {
    height: '5.5rem',
    padding: '1rem 1.25rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.65rem',
  },
  image: {
    width: 44,
    height: 44,
    objectFit: 'contain',
  },
  wordmark: {
    display: 'flex',
    alignItems: 'baseline',
  },
  textAccent: {
    fontFamily: sharedFonts.main,
    fontSize: '2rem',
    fontWeight: 700,
    letterSpacing: '0.05rem',
    color: '#1D4ED8',
  },
  text: {
    fontFamily: sharedFonts.main,
    fontSize: '1.55rem',
    fontWeight: 600,
    letterSpacing: '0.05rem',
    color: sharedColors.black,
  },
};
